const isStringNotEmpty = (value) => (!!value);

export default isStringNotEmpty;
